export enum TestStatus {
  Fail = "fail",
  Skip = "skip",
  SilentFail = "silentfail",
  Pass = "pass",
  Timeout = "timeout",
}
